<style >
.team-member .v-toolbar__content {
  padding-left:0px;
}
</style>
<template>
<div class="team-member" >
  <!-- member details -->
  <v-dialog width="460" v-model="viewprofiledialog" >
    <v-card v-if="practitioner && practitioner.profile_picture">
      <v-btn x-small fab absolute top right
        :fullscreen="$vuetify.breakpoint.xs"
        @click="viewprofiledialog=false"
        class="mt-5" ><v-icon>mdi-close</v-icon></v-btn>
      <v-img :src="practitioner.profile_picture" />
    </v-card>
  </v-dialog>
  <v-toolbar v-if="practitioner && practitioner.user" dense class="pl-0" >
    <v-avatar @click="viewprofiledialog=true" tile >
      <v-img class="left"
        v-if="practitioner.profile_picture"
        :src="practitioner.profile_picture" />
      <v-icon v-else >mdi-account-circle</v-icon>
    </v-avatar>
    <v-divider vertical class="mr-3" />

    <v-toolbar-title v-if="user" >
      {{user.first_name}} {{user.last_name}}
    </v-toolbar-title>
    <v-chip
      v-if="practitioner && practitioner.is_active === false"
      small color="warning" class="ml-2" >
      <v-icon left small >mdi-power-plug-off-outline</v-icon>
      Deactivated</v-chip>
    <v-spacer/>
    <!-- <v-chip small class="mr-2" >{{ member.member_type }}</v-chip> -->

    <help-chip v-if="memberTypeExplanation"
      :info-text="memberTypeExplanation" class="mr-2" >{{ member.member_type }}</help-chip>

    <v-chip small
      v-if="flags.package && pkg && pkg.title"
      @click="actionId='change_package'"
      class="ml-2" color="info" >
      <v-icon left small >mdi-star</v-icon>
      {{ pkg.title }}
      <v-icon x-small right >mdi-pencil</v-icon>
    </v-chip>

    <!-- :disabled="member.member_type !== 'Dependent'" -->
    <action-menu
      context="practitioner"
      :action-id.sync="actionId"
      :member="selectedMembership"
      :practitioner="practitioner"
      :business-id="businessId"
      :disabled="!practitioner.is_active"
      @saved="saved" />

    <v-btn icon @click="get" ><v-icon>mdi-refresh</v-icon></v-btn>
  </v-toolbar>
  <v-divider/>
  <request-status :request="requests.get" :message200="false" />

  <!-- general member settings -->
  <v-card flat tile >
    <v-overlay absolute v-if="requests.get.loading" >
      <v-progress-circular size="72" color="amber" indeterminate />
    </v-overlay>
    <v-card-title class="overline py-1 grey lighten-4" >
      {{user.first_name}} {{user.last_name}}
      <v-spacer/>
      <v-btn x-small outlined
        :disabled="!isDependent"
        @click="editprofiledialog=true" >
        <v-icon x-small >mdi-pencil</v-icon> edit</v-btn>
    </v-card-title>

    <v-dialog fullscreen v-model="editprofiledialog" >
      <v-card>
        <v-btn fab top right small absolute
          class="mt-8 mr-3"
          @click="editprofiledialog=false" >
          <v-icon small >mdi-close</v-icon>
        </v-btn>
        <v-card-text class="pt-3" >
          <edit-team-member :user-id="practitionerId" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-alert tile
      v-if="!isAccountActive" type="error" class="mb-0" >
      This user has been deactivated.
      <v-btn flat outlined small
        class="float-right"
        @click="actionId='reactivate_account'" >Reactivate</v-btn>
    </v-alert>

    <v-card-text>
      <strong class="mr-1">Username:</strong> {{ practitioner.sub_domain }} <br/>
      <strong class="mr-1">Email:</strong>
      <template v-if="user.email" >
        <span v-if="emailIsDeactivated" class="red--text ml-1" >Deactivated</span>
        <template v-else class="ml-1" >

          <span >{{ user.email }}</span>
          <v-tooltip bottom  >
            <template v-slot:activator="{ on, attrs }" >
              <v-icon x-small v-bind="attrs" v-on="on" class="ml-1"
                @click="copyText(user.email)" >mdi-content-copy</v-icon>
            </template>
            <span>copy <code>{{user.email}}</code> to clipboard </span>
          </v-tooltip>

        </template><br/>
        <template v-if="practitioner.sub_domain && !emailIsDeactivated" >
          <strong class="mr-1">Email forward:</strong>
          {{redirectEmail}}
          <v-tooltip bottom  >
            <template v-slot:activator="{ on, attrs }" >
              <v-icon x-small v-bind="attrs" v-on="on" class="mx-1"
                @click="copyText(redirectEmail)" >mdi-content-copy</v-icon>
            </template>
            <span>copy <code>{{redirectEmail}}</code> to clipboard </span>
          </v-tooltip>
          <v-icon small >mdi-arrow-right</v-icon>
          {{user.email}}<br/>
        </template>
      </template>

      <strong class="mr-1">Phone number:</strong>
      <span v-if="user.phone_number" v-text="user.phone_number" />
      <span v-else class="ml-1" >None specified</span>

      <div>
      <strong >Registratoni number: </strong> {{practitioner.registration_number || 'n/a'}}
      </div>

      <!-- <pre v-text="user" /> -->
    </v-card-text>

    <asset-view :practitioner="practitioner" object-type="practitioner" idPath="user.id" />

    <v-card :disabled="activeMembers && activeMembers.length === 0" >
      <member-actions
        :business-id="businessId"
        :practitioner="practitioner"
        :visible="showmanage"
        @saved="get" />
      <v-alert tile
        v-if="activeMembers && activeMembers.length === 0"
        class="caption" type="info" >
        Actions disabled because there are no active memberships
      </v-alert>
    </v-card>

  </v-card>

  <!-- member settings @space -->

  <v-subheader class="overline mt-3" >Memberships</v-subheader>
  <template v-for="member in activeMembers" >

    <v-card class="mt-4"
      :disabled="member.service_data.archived"
      :key="`card-${member.id}`" >

      <v-card-title class="overline py-1 grey lighten-4" >
        {{member.practitioner_name}} @
        {{member.service_data.title}}
        <v-spacer/>
        <v-chip small v-if="member.service_data.archived" class="mr-2" color="warning" >Archived</v-chip>
      </v-card-title>
      <v-divider/>
      <v-alert tile
        v-if="member.is_archived && isActive" type="warning" >
        This membership is archived.
        This user cannot see assets shared in this space ({{ member.service_data.title }})<br/>
        <!-- <pre v-text="selectedMembership" class="caption" /> -->
        <v-btn flat outlined small
          @click="selectedMembership=member;actionId='toggle_space'"
          class="mt-2 float-right" >Unarchive</v-btn>
      </v-alert>

      <v-card-text>
        <strong>Role:</strong>
        <v-chip small outlined
          v-if="!isOwner"
          @click="selectedMembership=member;actionId='change_role'"
          class="mx-2" >
          {{member.role}}
          <v-btn x-small icon right >
            <v-icon x-small >mdi-pencil</v-icon>
          </v-btn>
        </v-chip>
        <v-chip v-else small outlined class="mx-2" >Account owner</v-chip>

        <div>
          <strong>Profession:</strong> {{member.practitioner_profession || 'not set'}}
        </div>

        <div>
          <strong>Created:</strong> {{ dateformat(member.created_date) }}<br/>
        </div>
      </v-card-text>

      <v-divider/>
      <v-card-actions >
        <v-btn small
          v-if="isActive(member)"
          @click="selectedMembership=member;actionId='toggle_space'"
          color="error" >Terminate Membership</v-btn>
      </v-card-actions>

    </v-card>


  </template>

  <template v-if="(archivedMembers && archivedMembers.length > 0)" >
    <v-subheader class="overline mt-3" >Archived memberships</v-subheader>
    <v-list class="mt-2" >
      <template v-for="member in archivedMembers" >
        <v-list-item :key="member.id">
          <v-list-item-content>
            <v-list-item-title>
              {{member.role}}
              <span v-if="member.service_data" >@ {{member.service_data.title}}</span>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action >
            <v-btn flat outlined small
              @click="selectedMembership=member;actionId='toggle_space'"
              class="mt-2 float-right" >Unarchive</v-btn>
          </v-list-item-action>
          <!-- <pre v-text="member" class="caption pa-2 grey lighten-4" /> -->
        </v-list-item>
        <v-divider :key="`div-${member.id}`" />

      </template>
    </v-list>
  </template>

</div>
</template>
<script>

// import PermissionPicker from '@/components/pickers/PermissionsPicker.vue'
// import AppointmentTypesPage from '@/views/space/AppointmentTypesPage.vue'
// import OperatingHours from '@/views/profile/OperatingHours.vue'
import EditTeamMember from './EditTeamMember.vue'
import MemberActions from './MemberActions.vue'
import ActionMenu from './actions/ActionMenu.vue'
import AssetView from './AssetView.vue'
import HelpChip from '@/components/ui/HelpChip.vue'

import {EXPLANATIONS} from '@/store/constants.js'

// flags
const PACKAGES_ENABLED = false

export default {
  name: 'TeamMember',
  components: {
    EditTeamMember,
    MemberActions,
    // AppointmentTypesPage,
    // PermissionPicker,
    ActionMenu,
    AssetView,
    HelpChip
},
  props: {
    businessId: { required: true },
    practitionerId: { required: true },
    tab: { type: String, required: false }
  },
  data () {
    return {
      page: "1",
      actionId: null,
      showmembershipdetails: false,
      editprofiledialog: false,
      viewprofiledialog: false,
      activeTab: null,
      selectedMembership: null,
      showmanage: false,
      flags: {
        packages: PACKAGES_ENABLED,
      },
      requests: {
        get: {
          // resource: 'ag.spaces.members',
          resource: 'ag.business',
          result: {},
          extra: 'practitioner'
        }
      }
    }
  },
  mounted () {
    this.get()
    if (this.tab === 'start') {
      this.showmanage = true
    }
  },
  watch: {
    practitionerId () {
      this.page = null
      this.get()
    }
  },
  methods: {
    get () {
      if (this.businessId && this.practitionerId) {
        this.requests.get.params = {p: this.practitionerId}
        this.requests.get.resourceId = this.businessId
        this.$request('get', this.requests.get)
      }
    },
    saved (obj) {
      this.get()
      this.$emit('saved', obj)
    },
    isActive (member) {
      return member.is_active === true && member.is_archived === false
    }
  },
  computed: {
    member () {
      let mem = this.getObjectPath(this.requests.get, 'result', {})
      if (mem && mem.practitioner && mem.practitioner.user.id) {
        mem.practitioner.id = mem.practitioner.user.id
      }
      return mem
    },
    isDependent () {
      return (this.practitioner && this.practitioner.is_dependent)
    },
    isOwner () {
      return (this.member && this.member.member_type && this.member.member_type === 'Billable contact')
    },
    practitioner () {
      return this.getObjectPath(this.requests.get, 'result', {})
      // return this.getObjectPath(this.member, 'practitioner', {})
    },
    // practitionerId () {
    //   return this.getObjectPath(this.user, 'id')
    // },
    user () {
      return this.getObjectPath(this.practitioner, 'user', {})
    },
    members () {
      return this.getObjectPath(this.practitioner, 'memberships', [])
    },
    activeMembers () {
      return this.members.filter((member) => {
        return (member.is_active === true && member.is_archived === false)
      })
    },
    archivedMembers () {
      return this.members.filter((member) => {
        return (member.is_active === false && member.is_archived === true)
      })
    },
    redirectEmail () {
      return this.practitioner.sub_domain + '@appt.guru'
    },
    isAccountActive () {
      return this.getObjectPath(this.practitioner, 'user.is_active', true)
    },
    // isActive () {
    //   return this.getObjectPath(this.member, 'practitioner.user.is_active', {})
    // },
    emailIsDeactivated () {
      return (this.user.email && this.user.email.startsWith('deactivated-'))
    },
    pkg () {
      return this.getObjectPath(this.member, 'seat.package', {})
    },
    memberTypeExplanation () {
      if (this.member && this.member.member_type) {
        return EXPLANATIONS[this.member.member_type]
      }
      return null
    }
  }
}
</script>
